export default __webpack_public_path__ + "static/amsterdam-b88722c7428519b06a2dc858b9b19a6d.png";